export default {
  LoyaltyTierBadge__A_LIST: "A-List",
  LoyaltyTierBadge__A_LIST_PREFERRED: "A-List Preferred",
  LoyaltyTierBadge__PENDING: "Status Pending",
};
